import { FixaProductIdentifier } from "@coworker/apprestructured/src/shared/wrappers/FixaProductIdentifier/FixaProductIdentifier";
import React from "react";

export const ItemNo = ({ itemNo }: { itemNo: string }) => {
  return <FixaProductIdentifier value={itemNo} />;
};
